import React, {useState} from 'react';
import UserList from "@pages/user/UserList";
import {ORDER_BY, USER_ROLE} from "@app/constants/Common";

const MemberList = () => {
    return (
        <UserList title={"Danh sách MB"} role={USER_ROLE.EMPLOYEE}/>
    );
};

export default MemberList;
